module.exports = __webpack_public_path__ + "img/open_in_new.c72fc740.svg";